import React, {useState} from 'react';
import {AppProvider} from '@thinkwell/react.polaris';
import CourseTree from './CourseTree'
import {CourseTreeProvider} from '../contexts/CourseTree'

export default function Show(props) {
  return (
  <AppProvider>
  <CourseTreeProvider item={props.item}>
  <CourseTree />
  </CourseTreeProvider>
  </AppProvider>)
}
